import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { AffiliateProgramView } from 'views/information-module/AffiliateProgramView';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { API } from 'lib/config/axios';
import { HydrationWrapper } from 'views/common/components';

const AffiliateProgramPage = (props) => {
  const { seoValues } = props;
  return (
    <HydrationWrapper>
      <AffiliateProgramView ssrSeoValues={seoValues?.seo_values} />
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const {
    locale, req, res, pathname,
  } = ctx;
  const ssrRender = isCrawlers(req.headers['user-agent']);
  let layoutData = null;
  let seoValues = null;
  let serverError = null;

  if (ssrRender && pathname != '/_error') {
    const [layoutRes, seoValuesRes] = await Promise.all([
      serverFetch(ctx, API.layout),
      serverFetch(ctx, API.seoValues),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
    } else {
      res.statusCode = 503;
      throw new Error('Rendering halted because we failed to load layout data');
    }
    if (seoValuesRes.success && seoValuesRes.data) {
      seoValues = { seo_values: seoValuesRes.data };
    } else {
      serverError = {
        statusCode: seoValuesRes?.error?.response?.status,
      };
    }
  }
  const hreflangData = generateHreflang(PATHS.affiliateProgram().url, locale);
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_affiliate_program_page',
      ])),
      hreflangData,
      seoValues,
      layoutData,
      ssrRender,
      serverError,
      options: {
        showAiChat: true,
      },
    },
  };
}
export default AffiliateProgramPage;
